import TitleBlock from '@anm/components/TitleBlock';
import RedeemWaveCoupon from '@anm/components/subscription/RedeemWaveCoupon';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../store/modules/user';
import UserBillingInfo from '../UserBillingInfo';
import UserCurrentPlan from '../UserCurrentPlan';
import UserInvoiceHistory from '../UserInvoiceHistory';
import UserLimits from '../UserLimits';
import UserPaymentDetails from '../UserPaymentDetails';

import UserSubscriptionWrapper, { BillingInfoBlockWrapper, UserSubscriptionFormRow } from './Wrapper';
import useRedeemCouponHandler from './hooks/useRedeemCouponHandler';

export { UserSubscriptionWrapper };

export type UserSubscriptionProps = {
  title?: string | null;
};

const UserSubscription: FC<UserSubscriptionProps> = ({ title = 'Subscription' }) => {
  const [handleRedeem, redeemError] = useRedeemCouponHandler();
  const teamRole = useSelector(userSelectors.selectTeamRole);
  const isSemrushUser = useSelector(userSelectors.isSemrushUser);

  const isSubscriptionOwner = (!teamRole || teamRole === 'OWNER') && !isSemrushUser;

  return (
    <UserSubscriptionWrapper>
      {title && <TitleBlock size="super-medium" {...{ title }} />}
      {isSubscriptionOwner && <RedeemWaveCoupon onRedeem={handleRedeem} error={redeemError} />}
      {isSubscriptionOwner && (
        <UserSubscriptionFormRow>
          <UserCurrentPlan />
          <UserPaymentDetails />
        </UserSubscriptionFormRow>
      )}
      <UserLimits />
      {isSubscriptionOwner && (
        <BillingInfoBlockWrapper>
          <UserBillingInfo />
        </BillingInfoBlockWrapper>
      )}
      {isSubscriptionOwner && <UserInvoiceHistory />}
    </UserSubscriptionWrapper>
  );
};

export default UserSubscription;
